import { Label, Select, TextInput } from "flowbite-react";
import { UseFormRegisterReturn } from "react-hook-form";
import { countryCurrencyCodes } from "../../../data/countryCurrencyCode";

interface ModalFormCurrencySelectorProps {
    register: UseFormRegisterReturn,
    errors: Record<string, any>,
    fieldName: string,
    label: string
}

const ModalFormCurrencySelector = ({register, errors, fieldName, label}:ModalFormCurrencySelectorProps) => {
    return (
        <div>
            <div className="mb-2 block">
                <Label htmlFor={fieldName} value={label} />
            </div>
            <Select
                {...register}
            >
                {countryCurrencyCodes.map((item: any) => {
                    return (
                        <option value={item.code}>{item.country}</option>
                    )
                })}
            </Select>
            {errors && errors[fieldName] && (
                <div className="text-red-500 text-xs pt-2">{errors[fieldName].message}</div>
            )}
        </div>
    )
}

export default ModalFormCurrencySelector;